import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PackagingType } from "types/packaging";
import { fetchPackagingTypesThunk } from "store/thunks/packagingThunks";

interface PackagingState {
	data: PackagingType[];
	loading: boolean;
	error: string | null;
}

const initialState: PackagingState = {
	data: [],
	loading: false,
	error: null,
};

const packagingSlice = createSlice({
	name: "packaging",
	initialState,
	reducers: {
		clearPackagingData(state) {
			state.data = [];
			state.error = null;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchPackagingTypesThunk.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(
				fetchPackagingTypesThunk.fulfilled,
				(state, action: PayloadAction<PackagingType[]>) => {
					state.data = action.payload;
					state.loading = false;
				},
			)
			.addCase(fetchPackagingTypesThunk.rejected, (state, action) => {
				state.loading = false;
				state.error =
					typeof action.payload === "string"
						? action.payload
						: "Failed to fetch packaging types.";
			});
	},
});

export const { clearPackagingData } = packagingSlice.actions;
export default packagingSlice.reducer;
